import { createVueApp, SentryTracking, setupI18n, ENGLISH_LOCALE, SPANISH_LOCALE } from '@hfc/ui-core';
import { appConfig } from '../AppConfig';
import App from '@/App.vue';
import '@hfc/ui-core/dist/index.css';
import '@/shared/infrastructure/main.css';
import i18nEn from '@/shared/i18n/en.json';
import i18nEs from '@/shared/i18n/es.json';
import { PageStore } from '@/page/infrastructure/store/PageStore';
import { PostStore } from '@/blog/infrastructure/store/PostStore';
import { StaffMemberStore } from '@/shared/infrastructure/store/StaffMemberStore';
import VueLazyLoad from 'vue3-lazyload';

setupI18n({ [ENGLISH_LOCALE]: i18nEn, [SPANISH_LOCALE]: i18nEs });

const app = await createVueApp(App, appConfig);
const sentry = new SentryTracking(appConfig.tracking, app);

sentry.init();

app.provide('PageStore', new PageStore());
app.provide('PostStore', new PostStore());
app.provide('StaffMemberStore', new StaffMemberStore());
app.use(VueLazyLoad, {
  log: false,
  observerOptions: {
    rootMargin: '300px', // This is to start calling the img 100px before it appears
    threshold: 0
  }
});

app.mount('#app');
